import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ContactformComponent } from './contactform.component'
import { ContactformService } from './contactform.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { I18nModule, ConfigModule, UrlModule } from '@spartacus/core'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [ContactformComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NgSelectModule,
    UrlModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['contactus'],
        },
      },
    }),
  ],
  exports: [ContactformComponent],
  providers: [ContactformService],
})
export class ContactformModule {}
